// extracted by mini-css-extract-plugin
export var closeButton = "_fy-2";
export var closeButtonIcon = "_fy-3";
export var lightboxContent = "_fy-1";
export var lightboxOverlay = "_fy-0";